import { ClassGroup, EnrollmentStatus } from 'modules/arena/class-groups/types';

export const ENROLLMENT_STATUS_LABELS: Record<EnrollmentStatus, string> = {
  ativa: 'Ativa',
  pendente_renovacao: 'Pendente de renovação',
  cancelada: 'Cancelada',
};

// Turma B casa com o que o jogador (persona demo Rafael Nunes) já vê no app dele
// em pages/Classes — mesmo esporte, instrutora, quadra, horário e valor.
export const MOCK_CLASS_GROUPS: ClassGroup[] = [
  {
    id: 'turma-b',
    name: 'Turma B',
    sport: 'Beach Tennis',
    instructor: 'Prof. Camila Rocha',
    court: 'Areia 2',
    scheduleLabel: 'Ter e Qui · 07:00',
    durationLabel: '1h',
    capacity: 6,
    monthlyPrice: 250,
    status: 'ativa',
    renewalMode: 'automatica',
    cancellationPolicySnapshot: 'Reposição em até 7 dias · sem reembolso após o início do mês',
    students: [
      { id: 'rafael', name: 'Rafael Nunes', status: 'ativa', sinceLabel: 'mai/26' },
      { id: 'marina', name: 'Marina L.', status: 'ativa', sinceLabel: 'jun/26' },
      { id: 'ana', name: 'Ana P.', status: 'ativa', sinceLabel: 'jun/26' },
      { id: 'leo', name: 'Léo S.', status: 'pendente_renovacao', sinceLabel: 'jul/26' },
      { id: 'bia', name: 'Bia R.', status: 'ativa', sinceLabel: 'ago/26' },
    ],
    upcomingSessions: [
      {
        id: 'turma-b-10set',
        dateLabel: '10 set (qui)',
        timeLabel: '07:00',
        attendanceTaken: true,
        presentStudentIds: ['rafael', 'marina', 'ana', 'bia'],
      },
      { id: 'turma-b-17set', dateLabel: '17 set (ter)', timeLabel: '07:00', attendanceTaken: false, presentStudentIds: [] },
      { id: 'turma-b-19set', dateLabel: '19 set (qui)', timeLabel: '07:00', attendanceTaken: false, presentStudentIds: [] },
    ],
  },
  {
    id: 'futevolei-iniciantes',
    name: 'Futevôlei Iniciantes',
    sport: 'Futevôlei',
    instructor: 'Prof. Rui Almeida',
    court: 'Areia 2',
    scheduleLabel: 'Seg e Qua · 18:00',
    durationLabel: '1h',
    capacity: 8,
    monthlyPrice: 220,
    status: 'ativa',
    renewalMode: 'manual',
    cancellationPolicySnapshot: 'Reposição em até 7 dias · sem reembolso após o início do mês',
    students: [
      { id: 'diego', name: 'Diego C.', status: 'ativa', sinceLabel: 'mar/26' },
      { id: 'julia', name: 'Júlia M.', status: 'ativa', sinceLabel: 'mar/26' },
      { id: 'carla', name: 'Carla M.', status: 'ativa', sinceLabel: 'abr/26' },
      { id: 'bruno', name: 'Bruno T.', status: 'ativa', sinceLabel: 'mai/26' },
      { id: 'paula', name: 'Paula K.', status: 'ativa', sinceLabel: 'mai/26' },
      { id: 'igor', name: 'Igor F.', status: 'cancelada', sinceLabel: 'jun/26' },
      { id: 'renata', name: 'Renata V.', status: 'ativa', sinceLabel: 'jul/26' },
      { id: 'thiago', name: 'Thiago B.', status: 'ativa', sinceLabel: 'ago/26' },
    ],
    upcomingSessions: [
      { id: 'futevolei-15set', dateLabel: '15 set (seg)', timeLabel: '18:00', attendanceTaken: false, presentStudentIds: [] },
      { id: 'futevolei-17set', dateLabel: '17 set (qua)', timeLabel: '18:00', attendanceTaken: false, presentStudentIds: [] },
    ],
  },
  {
    id: 'pickleball-avancado',
    name: 'Pickleball Avançado',
    sport: 'Pickleball',
    instructor: 'Prof. Yuri Santos',
    court: 'Quadra 5',
    scheduleLabel: 'Sex · 19:00',
    durationLabel: '1h',
    capacity: 4,
    monthlyPrice: 280,
    status: 'pausada',
    renewalMode: 'manual',
    cancellationPolicySnapshot: 'Reposição em até 7 dias · sem reembolso após o início do mês',
    students: [
      { id: 'fernanda', name: 'Fernanda O.', status: 'ativa', sinceLabel: 'ago/26' },
      { id: 'caio', name: 'Caio R.', status: 'ativa', sinceLabel: 'ago/26' },
    ],
    upcomingSessions: [
      { id: 'pickleball-19set', dateLabel: '19 set (sex)', timeLabel: '19:00', attendanceTaken: false, presentStudentIds: [] },
    ],
  },
  {
    id: 'volei-praia-mista',
    name: 'Vôlei de Praia Mista',
    sport: 'Vôlei de Praia',
    instructor: 'Prof. Rui Almeida',
    court: 'Areia 3',
    scheduleLabel: 'Sáb · 08:00',
    durationLabel: '1h30',
    capacity: 10,
    monthlyPrice: 200,
    status: 'ativa',
    renewalMode: 'automatica',
    cancellationPolicySnapshot: 'Reposição em até 7 dias · sem reembolso após o início do mês',
    students: [
      { id: 'marcos', name: 'Marcos P.', status: 'ativa', sinceLabel: 'jun/26' },
      { id: 'sofia', name: 'Sofia N.', status: 'ativa', sinceLabel: 'jun/26' },
      { id: 'gabriel', name: 'Gabriel D.', status: 'ativa', sinceLabel: 'jul/26' },
      { id: 'laura', name: 'Laura F.', status: 'ativa', sinceLabel: 'jul/26' },
      { id: 'vitor', name: 'Vitor H.', status: 'ativa', sinceLabel: 'ago/26' },
      { id: 'camille', name: 'Camille S.', status: 'pendente_renovacao', sinceLabel: 'ago/26' },
      { id: 'pedro', name: 'Pedro A.', status: 'ativa', sinceLabel: 'ago/26' },
    ],
    upcomingSessions: [
      { id: 'volei-13set', dateLabel: '13 set (sáb)', timeLabel: '08:00', attendanceTaken: true, presentStudentIds: ['marcos', 'sofia', 'gabriel', 'laura', 'pedro'] },
      { id: 'volei-20set', dateLabel: '20 set (sáb)', timeLabel: '08:00', attendanceTaken: false, presentStudentIds: [] },
    ],
  },
];
